import {
  Modal,
  Space,
  Typography,
  Divider,
  Tag,
  Button,
  Popconfirm,
  message,
  Spin,
  Flex,
  Tooltip,
} from "antd";
import moment from "moment";
import {
  capitalizeTranslated,
  dateTimeToUtc,
  formatCompactAmount,
  FormatDateTimeFun,
  formatLabel,
  onlyDate,
  sourceLookup,
  utcDateTimeToLocalPA,
} from "../../../shared";
import { useEffect, useState } from "react";
import { dashboardapi } from "../../../services/dashboardapi";
import { SyncOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { can } from "../../../Auth";

const { Title, Text } = Typography;
const TomorrowSessionModal = ({ open, appointmentId, onClose }) => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      fetchDetails();
    }
  }, [open]);

  const fetchDetails = async () => {
    if (!appointmentId) return;
    setLoading(true);
    try {
      const result = await dashboardapi?.getAppointmentEditById(appointmentId);
      if (result) {
        setDetails(result);
      } else {
        setDetails(false);
      }
    } catch (error) {
      message.error(error || "Failed to load appointment detail.");
      setDetails(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        title={
          <Space>
            <Title level={5} className="my-0">
              View Tomorrow's Session
            </Title>
            <Tag
              color={
                details?.status === "pending"
                  ? "gold"
                  : details?.status === "completed"
                    ? "green"
                    : "red"
              }
            >
              {capitalizeTranslated(details?.status)}
            </Tag>
          </Space>
        }
        centered
        width={700}
        open={open}
        onOk={onClose}
        onCancel={onClose}
      >
        {loading ? (
          <Flex justify="center" align="center" style={{ height: "200px" }}>
            <Spin
              size="large"
              indicator={
                <SyncOutlined
                  spin
                  style={{ color: "var(--main-color)", fontSize: "24px" }}
                />
              }
            />
          </Flex>
        ) : (
          <div className="my-3">
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Client Name:</Text>
              <Text>{details?.client?.name}</Text>
            </Space>
            <Divider />
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Father Name:</Text>
              <Text>{details?.client?.fatherName}</Text>
            </Space>
            <Divider />
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Age:</Text>
              <Text>{details?.client?.age}</Text>
            </Space>
            <Divider />
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Cnic No:</Text>
              <Text>{details?.client?.cnic_passport}</Text>
            </Space>
            <Divider />
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Session Time:</Text>
              <Flex gap={5} justify="end" vertical>
                {details?.sessions
                  ?.filter((list) => {
                    if (!list?.sessionDateTime) return false;
                    const sessionDate = dayjs(list.sessionDateTime);
                    return (
                      sessionDate.isSame(dayjs(), "day") || // today
                      sessionDate.isSame(dayjs().add(1, "day"), "day")
                    ); // tomorrow
                  })
                  ?.map((list, index) => (
                    <Tag key={index}>
                      {utcDateTimeToLocalPA(list?.sessionDateTime)}
                    </Tag>
                  ))}
              </Flex>
            </Space>
            <Divider />
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Issues:</Text>
              <div>
                {details?.client?.medical_history
                  ? Object.entries(details?.client?.medical_history)
                      .filter(
                        ([key, value]) => key.startsWith("is") && value === "1",
                      )
                      .map(([key, value], i) => (
                        <Tag key={i}>{formatLabel(key)}</Tag>
                      ))
                  : "-"}
              </div>
            </Space>
            <Divider />
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Telephone:</Text>
              <Text>
                {details?.client?.countryCode +
                  " " +
                  details?.client?.telephone}
              </Text>
            </Space>
            <Divider />
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Registration:</Text>
              <Text>
                {moment(details?.client?.register_date).format("MMM Do YYYY")}
              </Text>
            </Space>
            <Divider />

            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Occupation:</Text>
              <Text>{details?.client?.occuption}</Text>
            </Space>
            <Divider />
            <Space style={{ justifyContent: "space-between", width: "100%" }}>
              <Text strong>Source of Information:</Text>
              <Text>{details?.client?.other_source}</Text>
            </Space>
            <Divider />
            {can("Session", "view payment details") && (
              <Space style={{ justifyContent: "space-between", width: "100%" }}>
                <Space>
                  <Text strong>Total Amount:</Text>
                  <Text>
                    {formatCompactAmount(details?.totalPayment)} (PKR)
                  </Text>
                </Space>
                <Space>
                  <Text strong>Advance:</Text>
                  <Text>
                    {formatCompactAmount(details?.advancePayment)} (PKR)
                  </Text>
                </Space>
                <Space>
                  <Text strong>Remaining:</Text>
                  <Text>{formatCompactAmount(details?.duePayment)} (PKR)</Text>
                </Space>
              </Space>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};
export { TomorrowSessionModal };
